import React, { FC, useMemo } from 'react';
import { JsonForms } from '@jsonforms/react';
import { twJoin } from 'tailwind-merge';
import {
  FormState,
  UploadFormData,
} from '@shared/types/validationSpecialist';
import { combineDisplayRenderers } from './../EDTFForm/renderers';

type ParticipantFormDisplayProps = {
  uploadFormSchema: UploadFormData;
  edtfData: FormState;
  dark?: boolean;
};

export const ParticipantFormDisplay: FC<ParticipantFormDisplayProps> = ({
  uploadFormSchema,
  edtfData,
  dark,
}) => {
  const { cells, renderers } = useMemo(() => {
    return combineDisplayRenderers(dark);
  }, [dark]);

  if (!uploadFormSchema || !edtfData) {
    return null;
  }

  return (
    <div className={twJoin('px-[10px]', dark && 'dark-theme text-white')}>
      <JsonForms
        schema={uploadFormSchema.schema}
        uischema={uploadFormSchema.uiSchema}
        data={edtfData}
        renderers={renderers}
        cells={cells}
        readonly={true}
      />
    </div>
  );
};
